import Swiper from 'swiper'
import { Pagination } from 'swiper/modules'

class ProductGrid extends HTMLElement {
    constructor() {
        super();
        this.gridItems = [];
        this.selectedVariant = null;
        this.sideCart = document.querySelector('side-cart');
        this.cart = null;
        this.descEl   = document.querySelector('[data-desc]');
        this.readMore = document.querySelector('[data-read-more]');
        this.expanded = false;
        this._t       = null;
        this.lastWidth = window.innerWidth;
    }

    connectedCallback() {
        const fallback = document.querySelector('.plp-no-js')
        const algoliaRoot = document.querySelector('.algolia-shopify-instantsearch')

        fallback?.remove()
        algoliaRoot?.removeAttribute('hidden')

        const search = window.algoliaShopify?.instantsearch?.search;

        if (search) {
            search.on('render', () => {
                clearTimeout(this._renderTimer);
                this._renderTimer = setTimeout(() => this.init(), 16);
            });
        }

        // If Algolia is already loaded, initialize immediately
        if (this.querySelector('.ais-Hits-item')) {
            requestAnimationFrame(() => this.init());
        }

        this.addEventListener('click', this.onGridClick.bind(this), true);

        const toggles = document.querySelectorAll('.menu-toggle, .ais-close, .ais-overlay');
        toggles.forEach(el => {
            el.addEventListener('click', e => {
                e.preventDefault();
                document.querySelectorAll('.ais-facets, .ais-overlay')
                    .forEach(node => node.classList.toggle('facets--active'));
                document.body.classList.toggle('facets--active-overflow');
            });
        });

        document.addEventListener('keydown', e => {
            if (e.key === 'Escape') {
                const openFacet = document.querySelector('.ais-facets.facets--active');
                if (openFacet) {
                    document.querySelectorAll('.ais-facets, .ais-overlay')
                        .forEach(node => node.classList.remove('facets--active'));
                    document.body.classList.remove('facets--active-overflow');
                }
            }
        });

        // Coll Description Read More
        if (!this.descEl || !this.readMore) return;
        this.readMore.addEventListener('click', this.toggleExpand.bind(this));
        this.checkDescriptionOverflow();
        this.expanded = false;
        window.addEventListener('resize', () => {
            if (window.innerWidth !== this.lastWidth) {
                this.lastWidth = window.innerWidth;
                this.checkDescriptionOverflow();
            }
        });
    }

    async init() {
        this.gridItems = this.querySelectorAll('.ais-Hits-item')
        this.initVariantSwipers();
        await this.renderFeaturedFilters()
        this.renderActiveFilters()
        this.addProductBadges();

        setTimeout(() => {
            if (typeof window.yotpoWidgetsContainer !== "undefined") {
                window?.yotpoWidgetsContainer?.initWidgets();
            }
        }, 500);

        document.addEventListener('cart:change', e => {
            this.cart = e.detail;
            this.updateQuantities();
        });
					
    }

		onGridClick(e) {
				const hitEl = e.target.closest('.ais-Hits-item');

				if (!hitEl) return;


				const swiperBtns = hitEl.querySelectorAll('.swiper-button-prev, .swiper-button-next');

				const swiperEl = hitEl.querySelector('.variant-image-slider');        
				const swiper = swiperEl ? swiperEl.swiper : null;
					
					for (const btn of swiperBtns) {
						if (btn.contains(e.target)) {
							e.preventDefault();
							e.stopPropagation();
					
							if (!swiper) {
								console.warn('No swiper instance found for this hit');
								return;
							}
					
							if (btn.classList.contains('swiper-button-prev')) {
								swiper.slidePrev();
							} else {
								swiper.slideNext();
							}
					
							return;
						}
					}
					
					const addBtn = e.target.closest('button[data-add-to-cart]');
					if (addBtn) {
							e.preventDefault(); e.stopImmediatePropagation();
							return this.onAddToCart(hitEl, addBtn);
					}

					const qtyWrapper = e.target.closest('[data-quantity-selector]');

					if (qtyWrapper) {
						e.preventDefault(); 
						e.stopImmediatePropagation();

						const dec = e.target.closest('.quantity-selector-button.decrement');
						if (dec) {
								const input = hitEl.querySelector('input[name="quantity"]');
								let val = Number(input.value);
								if (val > 0) input.value = --val;
								return this.onQuantityChange(hitEl, input.value);
						}

						const inc = e.target.closest('.quantity-selector-button.increment');
						if (inc) {
								const input = hitEl.querySelector('input[name="quantity"]');
								input.value = Number(input.value) + 1;
								return this.onQuantityChange(hitEl, input.value);
						}
					}

		}

    renderActiveFilters() {
        const helper = window.algoliaShopify.instantsearch.search.helper;
        const state  = helper.state;
        const active = [];

        Object.entries(state.facetsRefinements).forEach(([attr, vals]) => {
            vals.forEach(val => active.push({ attr, val, type: 'facet' }));
        });

        Object.entries(state.disjunctiveFacetsRefinements).forEach(([attr, vals]) => {
            vals.forEach(val => active.push({ attr, val, type: 'disjunctive' }));
        });

        state.tagRefinements.forEach(val => {
            active.push({ attr: 'tag', val, type: 'tag' });
        });

        Object.entries(state.numericRefinements).forEach(([attr, ops]) => {
            Object.entries(ops).forEach(([operator, numbers]) => {
                numbers.forEach(number => {
                    active.push({
                        attr,
                        val: `${operator} ${number}`,
                        type: 'numeric'
                    });
                });
            });
        });

        const container = this.querySelector('.ais-active-filters-grid');
        if (!container) return;
        container.innerHTML = '';

        const clearButton = document.createElement('button');
        clearButton.className = 'clear-filters-button';
        clearButton.textContent = 'Clear All';
        clearButton.addEventListener('click', () => {
            helper.clearRefinements();
            helper.search();
        });

        active.forEach(({ attr, val, type }) => {
            if (attr === 'product_type') return;
            const pill = document.createElement('button');
            pill.type = 'button';
            pill.className = 'active-filter-pill';
            pill.textContent = `${val} ×`;
            pill.addEventListener('click', () => {

                if (type === 'facet') {
                    helper.removeFacetRefinement(attr, val);
                }
                else if (type === 'disjunctive') {
                    helper.removeDisjunctiveFacetRefinement(attr, val);
                }
                else if (type === 'tag') {
                    helper.removeTag(val);
                }
                else {
                    helper.clearRefinements(attr);
                }
                helper.search();
            });
            container.appendChild(pill);
        });
        container.appendChild(clearButton);

        if (active.length === 0) {
            clearButton.remove();
        }
    }

    async renderFeaturedFilters() {

        const search = window.algoliaShopify.instantsearch.search;
        const idx = search.indexName;

        const widgetState = search.renderState?.[idx]?.refinementList?.product_type;

        if (!widgetState?.items) return;

        const container = this.querySelector(
            '.ais-filter-container-grid .ais-facet-product_type-container-grid'
        );
        if (!container) return;
        container.innerHTML = '';

        widgetState.items.forEach(({ label, isRefined }) => {
            const svgIcon = this.getSvgIcon(label);
            const labelNew = this.getLabel(label);

            const safe = label.replace(/\W+/g, '-').toLowerCase();
            container.insertAdjacentHTML(
                'beforeend',
                `
            <div class="facet-item">
              <input
                type="checkbox"
                id="facet-product_type-${safe}"
                value="${label}"
                ${isRefined ? 'checked' : ''}
              />
              <label for="facet-product_type-${safe}">
                ${svgIcon}${labelNew}
              </label>
            </div>
          `
            );
        });

        container.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
            cb.addEventListener('change', (e) => {
                const v = e.target.value;
                container.querySelectorAll('input[type="checkbox"]').forEach(cb => {
                    cb.classList.remove('active');
                });
                if (e.target.checked) {
                    e.target.classList.add('active');
                    search.helper.addFacetRefinement('product_type', v);
                } else {
                    search.helper.removeFacetRefinement('product_type', v);
                }
                search.helper.search();
            });
        });
    }

    getLabel(label) {
        switch (label) {
            case 'Other Powders':
                return 'Powder';
            case 'Protein Powders':
                return 'Protein';
            default:
                return label;
        }
    }

    getSvgIcon(label) {
        switch (label) {
            case 'Chews':
                return window.product_type_svg.chews;
            case 'Powder':
                return window.product_type_svg.powder;
            case 'Other Powders':
                return window.product_type_svg.powder;
            case 'Capsule':
                return window.product_type_svg.capsule;
            default:
                return '';
        }
    }

    onAddToCart(hitEl, addBtn) {
        const form = hitEl.querySelector('form');
        const id   = Number(form.querySelector('input[name="id"]').value);
        const qty  = Number(form.querySelector('input[name="quantity"]').value);

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type':'application/json' },
            body: JSON.stringify({ id, quantity: qty })
        })
            .then(r => r.json())
            .then(() => {
                addBtn.classList.add('hidden');
                const qtyWrapper = hitEl.querySelector('[data-quantity-selector]');
                const qtyInput   = qtyWrapper.querySelector('input[name="quantity"]');

                this.getCurrentCartQty(id).then(qty => {
                    qtyInput.value = qty;
                })
                    .then(() => {
                        qtyWrapper.classList.remove('hidden');
                    });

                    Rebuy.SmartCart.show()

            })
            .catch(console.error);
    }

    getCurrentCartQty(id) {
        return fetch('/cart.js')
            .then(r => r.json())
            .then(data => {
                const item = data.items.find(item => item.id === id);
                // if there’s no matching line item, return 0
                return item ? item.quantity : 0;
            })
            .catch(err => {
                console.error('Error fetching cart:', err);
                return 0;
            });
    }

    onQuantityChange(hitEl, newQty) {
        const form = hitEl.querySelector('form');
        const id   = Number(form.querySelector('input[name="id"]').value);
        const addToCartBtn = form.querySelector('[data-add-to-cart]');
        const quantitySelector = form.querySelector('[data-quantity-selector]');
        const qtyInput = form.querySelector('input[name="quantity"]');

        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({
                updates: {
                    [id]: Number(newQty)
                }
            })
        })
            .then(r => r.json())
            .then(data => {

                if (newQty < 1) {
                    addToCartBtn.classList.remove('hidden');
                    quantitySelector.classList.add('hidden');
                    qtyInput.value = 1;
                }

            })
            .catch(console.error);
    }

    updateQuantities() {
        this.gridItems.forEach(item => {
            const id = Number(item.querySelector('form input[name="id"]').value);
            const qty = this.cart.items.find(item => item.id === id)?.quantity || 0;
            const quantityInput = item.querySelector('form input[name="quantity"]');

            if (!quantityInput) return;

            item.querySelector('form input[name="quantity"]').value = qty;
        });
    }


    initVariantSwipers() {
        this.querySelectorAll('.variant-image-slider').forEach((el) => {
            if (el.swiper) return;

            const nextBtn = el.querySelector('.swiper-button-next');
            const prevBtn = el.querySelector('.swiper-button-prev');

            const swiper = new Swiper(el, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 10,
                modules: [Pagination],
                navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                },
                pagination: {
                    el: el.querySelector('.swiper-pagination'),
                    clickable: true,
                },
            });

            el.swiper = swiper;

        });

    }

    nextSlide(swiper) {
        swiper.slideNext();
    }

    prevSlide(swiper) {
        swiper.slidePrev();
    }

    addProductBadges() {
        this.querySelectorAll('.ais-hit').forEach(item => {
            const container = item.querySelector('.product-badge-container');
            if (!container) return;
        
            const raw = container.getAttribute('data-product-badges');
            if (!raw) return;
        
            let entries;
            try {
                entries = JSON.parse(raw);
            } catch (e) {
                console.warn('Invalid badge JSON:', raw);
                return;
            }
            if (!Array.isArray(entries) || entries.length === 0) return;
        
            container.innerHTML = '';
        
            entries.forEach(entry => {
                const b = entry.product_badge;
                if (!b || !b.title) return;

                if(b.image) {
                    const div = document.createElement('div');
                    div.innerHTML = b.image;

                    container.appendChild(div);
                } else {
                    const span = document.createElement('span');
                    span.className   = 'product-badge';
                    span.title       = b.title + ' Badge';
                    span.textContent = b.title;
                    span.style.backgroundColor = b.background_color;
                    span.style.color = b.text_color;

                    container.appendChild(span);
                }
            });
        });
    }

    checkDescriptionOverflow() {
        if (this.expanded) {
            this.readMore.classList.remove('hidden');
            return;
        }

        if (!this.descEl || !this.readMore) return;

        setTimeout(() => {
            const hasOverflow = this.descEl.scrollHeight > this.descEl.clientHeight;
            this.readMore.classList.toggle('hidden', !hasOverflow);
        }, 100);
    }

    toggleExpand() {
        this.expanded = !this.expanded;
        this.descEl.classList.toggle('line-clamp-3', !this.expanded);
        this.readMore.textContent = this.expanded ? 'Read Less' : 'Read More';
    }

    debouncedCheckOverflow() {
        clearTimeout(this._t);
        this._t = setTimeout(() => this.checkDescriptionOverflow(), 100);
    }
}


customElements.define('product-grid',  ProductGrid);